import { SET_FORECAST_FREE_CASH_FLOW } from "./mutations";

const initialState = {
  forecastFreeCashFlow: null
};

const forecastFCFReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FORECAST_FREE_CASH_FLOW: {
      return { ...state, forecastFreeCashFlow: payload };
    }

    default:
      return state;
  }
};

export default forecastFCFReducer;
